import { render, staticRenderFns } from "./UserAccountForm.vue?vue&type=template&id=b6667092&"
import script from "./UserAccountForm.vue?vue&type=script&lang=js&"
export * from "./UserAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports